import { render, staticRenderFns } from "./FinalSphere.vue?vue&type=template&id=d517839c&"
import script from "./FinalSphere.vue?vue&type=script&lang=js&"
export * from "./FinalSphere.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports